<template>
  <div>
    <div v-if="topValue===2" class="main" style="width: 1344px;box-sizing: border-box;margin-left: 20px">
      <div class="mainContent" style="display: flex;flex-wrap: wrap;margin-top: 35px">
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">A区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">B区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">

                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox" style="margin-left: 0px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">C区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div style="height: 830px;margin-left: 10px;margin-right: 27px">
          <img src="@/assets/line.png" style="height: 100%" alt="">
        </div>
        <div>
          <div class="secondContent-box">
            <div style="display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
              <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">过渡段</div>
            </div>
            <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
              <div class="secondContent-box-main" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('gl_len')) }"
                   style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/length.png" style="width: 48px;height: 48px;">
                <div style="margin-left: 16px">
                  <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_len}}</div>
                  <div style="font-size: 14px;color: #FFFFFF;">长度</div>
                </div>
              </div>
              <div class="secondContent-box-main" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('gl_weed')) }"
                   style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
                <div style="margin-left: 16px">
                  <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_weed}}</div>
                  <div style="font-size: 14px;color: #FFFFFF;">速度</div>
                </div>
              </div>
            </div>

          </div>
          <div style="margin-top: 30px;display: flex;">
            <div class="secondContent-box-duan">
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟涨圈</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('yanshi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.yanshi}}</div>
                </div>
              </div>
            </div>
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟充气</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('chongqi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.chongqi}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;display: flex;">
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟喷水</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('ysps')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.ysps}}</div>
                </div>
              </div>
            </div>
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">喷水延迟</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('psys')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.psys}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;display: flex;">
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">排气延迟</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('paiqi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.paiqi}}</div>
                </div>
              </div>
            </div>
          </div>
<!--        211111-->
        </div>
        <div style="height: 830px;margin-left: 10px;margin-right: 27px">
          <img src="@/assets/line.png" style="height: 100%" alt="">
        </div>
      </div>
    </div>
    <div v-if="topValue===1" class="main" style="width: 1344px;box-sizing: border-box;margin-left: 20px">
      <div class="mainContent" style="display: flex;flex-wrap: wrap;margin-top: 35px">
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">A区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">B区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">

                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox" style="margin-left: 0px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">C区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div style="height: 830px;margin-left: 10px;margin-right: 27px">
          <img src="@/assets/line.png" style="height: 100%" alt="">
        </div>
        <div>
          <div class="secondContent-box">
            <div style="display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
              <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">过渡段</div>
            </div>
            <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
              <div class="secondContent-box-main" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('gl_len')) }"
                   style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/length.png" style="width: 48px;height: 48px;">
                <div style="margin-left: 16px">
                  <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_len}}</div>
                  <div style="font-size: 14px;color: #FFFFFF;">长度</div>
                </div>
              </div>
              <div class="secondContent-box-main" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('gl_weed')) }"
                   style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
                <div style="margin-left: 16px">
                  <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_weed}}</div>
                  <div style="font-size: 14px;color: #FFFFFF;">速度</div>
                </div>
              </div>
            </div>

          </div>
          <div style="margin-top: 30px;display: flex;">
            <div class="secondContent-box-duan">
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟涨圈</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('yanshi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.yanshi}}</div>
                </div>
              </div>
            </div>
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟充气</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('chongqi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.chongqi}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;display: flex;">
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">排气延迟</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('paiqi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.paiqi}}</div>
                </div>
              </div>
            </div>
          </div>
          <!--        211111-->
        </div>
        <div style="height: 830px;margin-left: 10px;margin-right: 27px">
          <img src="@/assets/line.png" style="height: 100%" alt="">
        </div>
      </div>
    </div>
    <div v-if="topValue===3" class="main" style="width: 1344px;box-sizing: border-box;margin-left: 20px">
      <div class="mainContent" style="display: flex;flex-wrap: wrap;margin-top: 35px">
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">A区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('a_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">B区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">

                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('b_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox" style="margin-left: 0px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">C区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_len')) }"
                 style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_weed')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_1')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_2')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_3')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管3出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_4')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管4出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('c_g_5')) }"
                 style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管5出力</div>
              </div>
            </div>
          </div>

        </div>
        <div style="height: 830px;margin-left: 10px;margin-right: 27px">
          <img src="@/assets/line.png" style="height: 100%" alt="">
        </div>
        <div>
          <div class="secondContent-box">
            <div style="display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
              <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">过渡段</div>
            </div>
            <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
              <div class="secondContent-box-main" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('gl_len')) }"
                   style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/length.png" style="width: 48px;height: 48px;">
                <div style="margin-left: 16px">
                  <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_len}}</div>
                  <div style="font-size: 14px;color: #FFFFFF;">长度</div>
                </div>
              </div>
              <div class="secondContent-box-main" :class="{'mainContentTopBox-box-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('gl_weed')) }"
                   style="margin-top: 19px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
                <div style="margin-left: 16px">
                  <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_weed}}</div>
                  <div style="font-size: 14px;color: #FFFFFF;">速度</div>
                </div>
              </div>
            </div>

          </div>
          <div style="margin-top: 28px;display: flex;">
            <div class="secondContent-box-duan">
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟涨圈</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('yanshi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.yanshi}}</div>
                </div>
              </div>
            </div>
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟充气</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('chongqi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.chongqi}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 28px;display: flex;">
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟喷水</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('ysps')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.ysps}}</div>
                </div>
              </div>
            </div>
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">喷水延迟</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('psys')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.psys}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 28px;display: flex;">
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">排气延迟</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('paiqi')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.paiqi}}</div>
                </div>
              </div>
            </div>
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">正转喷水</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('zzps')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.zzps}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 28px;display: flex;">
            <div class="secondContent-box-duan" >
              <div style="display: flex;justify-content: flex-start;align-items: center">
                <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
                <div style="font-size: 19px;font-weight: bold;color: #FFFFFF;margin-left: 10px">反转喷水</div>
              </div>
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <div class="secondContent-box-main-duan" :class="{'secondContent-box-main-duan-checked':((dataForm.change_field.length!==0 && true) && dataForm.change_field.includes('fzps')) }"
                     style="margin-top: 19px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
                  <img src="@/assets/number.png"
                       style="width: 35px;height: 35px;">
                  <div style="margin-left: 16px;font-size: 12px;color: #FFFFFF;text-align: center">数值</div>
                  <div style="font-size: 20px;font-weight: 500;color: #FFFFFF;margin-left: 10px">{{dataForm.fzps}}</div>
                </div>
              </div>
            </div>
          </div>
          <!--        211111-->
        </div>
        <div style="height: 830px;margin-left: 10px;margin-right: 27px">
          <img src="@/assets/line.png" style="height: 100%" alt="">
        </div>
      </div>
    </div>
    <div v-if="topValue===4" class="main" style="width: 1344px;box-sizing: border-box;margin-left: 20px">
      <div class="mainContent" style="display: flex;flex-wrap: wrap;margin-top: 35px">
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">A区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.a_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">B区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>

            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/5.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.b_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
          </div>

        </div>
        <div class="mainContentTopBox" style="margin-left: 0px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">C区</div>
          </div>
          <div style="margin-top: 12px;display: flex;justify-content: space-between;flex-wrap: wrap">
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_1}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/2.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_2}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/3.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_3}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/4.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_4}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管2出力</div>
              </div>
            </div>
            <div class="mainContentTopBox-box"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/1.png"
                   style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.c_g_5}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">管1出力</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="secondContent" style="display: flex;flex-wrap: wrap;margin-top: 25px">
        <div class="secondContent-box">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">过渡段</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/length.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_len}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">长度</div>
              </div>
            </div>
            <div class="secondContent-box-main"
                 style="margin-top: 14px;padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/speed.png" style="width: 48px;height: 48px;">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.gl_weed}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">速度</div>
              </div>
            </div>
          </div>

        </div>
        <div class="secondContent-box-duan">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟涨圈</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.yanshi}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>
        <div class="secondContent-box-duan">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟充气</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.chongqi}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>

        <div class="secondContent-box-duan" style="margin-left: 7px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">延迟喷水</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.ysps}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>
        <div class="secondContent-box-duan">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">喷水延迟</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.psys}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thirdContent" style="display: flex;flex-wrap: wrap;margin-top: 25px">
        <div class="secondContent-box-duan" style="margin-left: 7px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">排气延迟</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.paiqi}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>
        <div class="secondContent-box-duan" style="margin-left: 7px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">正转喷水</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.zzps}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>
        <div class="secondContent-box-duan" style="margin-left: 7px">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
            <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">反转喷水</div>
          </div>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <div class="secondContent-box-main-duan"
                 style="margin-top: 14px; padding: 16px 20px 16px 20px;box-sizing: border-box; display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/number.png" style="width: 48px;height: 48px;padding: 8px;box-sizing: border-box;border: 1px solid #74C5FF;border-radius: 8px">
              <div style="margin-left: 16px">
                <div style="font-size: 24px;font-weight: 500;color: #FFFFFF;">{{dataForm.fzps}}</div>
                <div style="font-size: 14px;color: #FFFFFF;">数值</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
  props: {
    dataForm: {
      type: Object,
      default: function () {
        return {}
      }
    },
    dialogTableVisible:{
      type: Boolean,
      default: false
    },
    topValue: {
      type: Number,
    }
  },
  components: {},
  data() {
    return {
      dialogTableVisible: false,
      form: {},
      activeIndex: 0,
      activeMainIndex: 0,
      searchForm: {
        pageSize: 16,
        pageNum: 1,
        type: 1
      },
      tableData: [
        {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        }, {
          xinghao: "GN65",
          genggai: "A区 长度",
          yuanzhi: "28",
          hou: "28",
          time: "2021/09/01 10:00:00"
        },
      ],
      topBoxList: [
        {
          name: "1号产线",
          active: true,
          mainList: [
            {
              name: "GN32",
              active: true,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            }, {
              name: "GN32",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            }, {
              name: "GN32",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            }, {
              name: "GN32",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            }, {
              name: "GN32",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            }, {
              name: "GN32",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            },
            {
              name: "GN50",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            },
            {
              name: "GN65",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              },
            },
          ],
        }, {
          name: "2号产线",
          active: false,
          mainList: [
            {
              name: "GN100",
              active: true,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              }, psyc: {
                length: 2.0,
              }, ycps: {
                length: 2.0,
              }
            },
            {
              name: "GN101",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              }, psyc: {
                length: 2.0,
              }, ycps: {
                length: 2.0,
              }
            },
            {
              name: "GN102",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              }, psyc: {
                length: 2.0,
              }, ycps: {
                length: 2.0,
              }
            },
          ],
        }, {
          name: "3号产线",
          active: false,
          mainList: [
            {
              name: "GN200",
              active: true,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              }, psyc: {
                length: 2.0,
              }, ycps: {
                length: 2.0,
              }
            },
            {
              name: "GN201",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              }, psyc: {
                length: 2.0,
              }, ycps: {
                length: 2.0,
              }
            },
            {
              name: "GN202",
              active: false,
              Asetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Bsetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Csetcion: {
                length: 28,
                speed: 3350,
                guan1: 28,
                guan2: 28
              },
              Guodu: {
                length: 28,
                speed: 3350,
              }, yanchiZT: {
                length: 2.0,
              }, yanchiCQ: {
                length: 2.0,
              }, qxyc: {
                length: 2.0,
              }, psyc: {
                length: 2.0,
              }, ycps: {
                length: 2.0,
              }
            },
          ],
        }
      ],
    }
  },
  mounted() {
    console.log(this.dataForm.length!==0)
    console.log(this.dialogTableVisible)
    console.log(this.dataForm.change_field.includes('a_len'))

  },
  methods: {
    popupStart(item, index) {
      this.dialogTableVisible = true
      this.form = item
    },
    clickTopBox(item, index) {
      this.topBoxList.forEach((item1) => {
        item1.active = false
      })
      this.topBoxList[index].active = true
      this.activeIndex = index
      this.$forceUpdate()
    },
    clickMainTopBox(item, index) {
      this.topBoxList[this.activeIndex].mainList.forEach((item1) => {
        item1.active = false
      })
      this.topBoxList[this.activeIndex].mainList[index].active = true
      this.activeMainIndex = index
      this.$forceUpdate()
    },
  }
}
</script>
<style scoped>
.header {
  background-image: url("@/assets/header-top.png");
  background-size: 100% 100%;
//box-sizing: border-box !important; padding-top: 7px; padding-bottom: 11px;
}

.top {
  height: 10% !important;
}

::v-deep.el-header {
  padding: 0 !important;

}

.top-box {
  background-image: url("@/assets/buttonNoActive.png");
  background-size: cover;
}

.activeBox {
  background-image: url("@/assets/buttonActive.png");
  background-size: cover;
  color: #000000 !important;
}

.mainTopBox {
  background-image: url("@/assets/buttonNoActive.png");
  background-size: cover;
  width: 131.5px;
  height: 41.5px;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  line-height: 34.5px;
  cursor: pointer;
  margin-right: 31.5px;
}

.mainTopBoxActive {
  background-image: url("@/assets/buttonActive.png");
  background-size: cover;
  color: #000000 !important;
}

.mainContentTopBox {
  width: 245px;
  height: 837px;
  box-sizing: border-box;
  padding: 12px 28px 28px 28px;
  background-image: url("@/assets/mainback.png");
  background-size: cover;
  margin-right: 20px;
}

.mainContentTopBox-box {
  background-color: #213957;
  width: 198px;
  height: 90px;
  background-image: url("@/assets/numberback.png");
  background-size: 100% 100%;
}
.mainContentTopBox-box-checked {
  background-color: #213957;
  width: 198px;
  height: 90px;
  background-image: url("@/assets/checked.png")!important;
  background-size: 100% 100%;
}

.secondContent-box {
  width: 416px;
  height: 165.5px;
  box-sizing: border-box;
  padding: 12px 28px 28px 28px;
  background-image: url("@/assets/backcolor.png");
  background-size: cover;
  margin-right: 19px;
}

.secondContent-box-main {
  background-color: #213957;
  width: 174px;
  height: 80px;
  background-image: url("@/assets/numberback.png");
  background-size: cover;
}

.secondContent-box-duan {
  width: 194px;
  height: 139px;
  box-sizing: border-box;
  padding: 12px 16px 16px 16px;
  background-image: url("@/assets/backcolorshort.png");
  background-size: cover;
  margin-right: 19px;
}

.secondContent-box-main-duan {
  background-color: #213957;
  width: 162px;
  height: 55px;
  background-image: url("@/assets/numberbacklittle.png");
  background-size: 100% 100%;

}
.secondContent-box-main-duan-checked {
  background-color: #213957;
  width: 162px;
  height: 55px;
  background-image: url("@/assets/shortchecked.png")!important;
  background-size: 100% 100%;

}

</style>
